import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import { connect } from 'react-redux';
import Admin from '../../wrappers/admin';

export const PrivateRoute = ({component: Component, ...rest}: any) => <Route 
     {...rest}
     render={(props:any) => (rest.auth)? (<Admin><Component {...props} /></Admin>): (<Redirect to={{pathname: '/login', state: {from: props.location}}} />)}     
/>;

const mapProps = (props:any) => ({auth: props.rootReducer.user.session});


export default connect(mapProps, null)(PrivateRoute)as any;